import { createSlice } from "@reduxjs/toolkit";

import { fetchList } from "@/entities/Personality/model/services/fetchList";

import type { PersonalitySchema } from "../types/personalitySchema";

const initialState: PersonalitySchema = {
  listIsLoading: false,
  listData: [],
};

export const personalitySlice = createSlice({
  name: "personality",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchList.pending, (state) => {
        state.listIsLoading = true;
        state.listError = undefined;
      })
      .addCase(fetchList.fulfilled, (state, action) => {
        state.listIsLoading = false;
        state.listData = action.payload;
      })
      .addCase(fetchList.rejected, (state, action) => {
        state.listIsLoading = false;
        state.listError = action.payload;
      });
  },
});

export const { actions: personalityActions, reducer: personalityReducer } = personalitySlice;
